export default __webpack_public_path__ + "static/vault-by-cnn-7b1f2417bcb36d525fb61f74d4520e87.png";